const CHART_WIDTH_S12FN = {
    "0": 6.6875,
    "1": 4.625,
    "2": 6.6875,
    "3": 6.6875,
    "4": 6.890625,
    "5": 6.6875,
    "6": 6.6875,
    "7": 6.46875,
    "8": 6.6875,
    "9": 6.6875,
    "q": 7.265625,
    "w": 8.78125,
    "e": 6.546875,
    "r": 4.28125,
    "t": 3.859375,
    "y": 5.875,
    "u": 6.9375,
    "i": 2.671875,
    "o": 7.28125,
    "p": 7.265625,
    "a": 6.40625,
    "s": 5.046875,
    "d": 7.265625,
    "f": 3.578125,
    "g": 7.265625,
    "h": 6.9375,
    "j": 2.671875,
    "k": 5.765625,
    "l": 2.671875,
    "z": 6.015625,
    "x": 5.46875,
    "c": 5.765625,
    "v": 5.875,
    "b": 7.265625,
    "n": 6.9375,
    "m": 10.65625,
    "Q": 9.78125,
    "W": 11.609375,
    "E": 6.484375,
    "R": 7.203125,
    "T": 6.640625,
    "Y": 7,
    "U": 8.40625,
    "I": 2.953125,
    "O": 9.875,
    "P": 7.0625,
    "A": 8.15625,
    "S": 6.453125,
    "D": 8.734375,
    "F": 6.03125,
    "G": 8.65625,
    "H": 8.78125,
    "J": 4.203125,
    "K": 6.828125,
    "L": 5.9375,
    "Z": 7.390625,
    "X": 7.296875,
    "C": 8.0625,
    "V": 7.828125,
    "B": 7.0625,
    "N": 9.1875,
    "M": 10.796875,
    "-": 5.15625,
    "=": 8.421875,
    "[": 3.65625,
    " ": 3.5625,
    "]": 3.65625,
    ";": 2.890625,
    "'": 2.78125,
    ",": 2.890625,
    ".": 2.890625,
    "·": 2.890625,
    "/": 4.75,
    "!": 3.6875,
    "@": 12.234375,
    "#": 7.828125,
    "$": 6.6875,
    "%": 10.171875,
    "^": 8.421875,
    "&": 9.03125,
    "*": 5.265625,
    "(": 3.65625,
    ")": 3.65625,
    "_": 5.390625,
    "+": 8.421875,
    "{": 3.65625,
    "}": 3.65625,
    ":": 2.890625,
    "\"": 4.34375,
    "&lt;": 8.421875,
    "&gt;": 8.421875,
    "?": 5.578125,
    "~": 8.421875,
    "`": 3.21875
}

const CHART_WIDTH_S14FN = {
    "0": 7.796875,
    "1": 5.390625,
    "2": 7.796875,
    "3": 7.796875,
    "4": 8.03125,
    "5": 7.796875,
    "6": 7.796875,
    "7": 7.546875,
    "8": 7.796875,
    "9": 7.796875,
    "q": 8.484375,
    "w": 10.234375,
    "e": 7.640625,
    "r": 5,
    "t": 4.5,
    "y": 6.859375,
    "u": 8.09375,
    "i": 3.109375,
    "o": 8.484375,
    "p": 8.484375,
    "a": 7.484375,
    "s": 5.875,
    "d": 8.484375,
    "f": 4.171875,
    "g": 8.484375,
    "h": 8.09375,
    "j": 3.109375,
    "k": 6.71875,
    "l": 3.109375,
    "z": 7.015625,
    "x": 6.375,
    "c": 6.71875,
    "v": 6.859375,
    "b": 8.484375,
    "n": 8.09375,
    "m": 12.4375,
    "Q": 11.40625,
    "W": 13.546875,
    "E": 7.5625,
    "R": 8.40625,
    "T": 7.734375,
    "Y": 8.171875,
    "U": 9.796875,
    "I": 3.453125,
    "O": 11.515625,
    "P": 8.234375,
    "A": 9.515625,
    "S": 7.515625,
    "D": 10.1875,
    "F": 7.03125,
    "G": 10.109375,
    "H": 10.234375,
    "J": 4.90625,
    "K": 7.96875,
    "L": 6.9375,
    "Z": 8.625,
    "X": 8.515625,
    "C": 9.40625,
    "V": 9.140625,
    "B": 8.234375,
    "N": 10.71875,
    "M": 12.59375,
    "-": 6.015625,
    "=": 9.828125,
    "[": 4.265625,
    " ": 4.15625,
    "]": 4.265625,
    ";": 3.359375,
    "'": 3.234375,
    ",": 3.359375,
    ".": 3.359375,
    "·": 3.359375,
    "/": 5.546875,
    "!": 4.3125,
    "@": 14.28125,
    "#": 9.140625,
    "$": 7.796875,
    "%": 11.859375,
    "^": 9.828125,
    "&": 10.546875,
    "*": 6.140625,
    "(": 4.265625,
    ")": 4.265625,
    "_": 6.28125,
    "+": 9.828125,
    "{": 4.265625,
    "}": 4.265625,
    ":": 3.359375,
    "\"": 5.078125,
    "&lt;": 9.828125,
    "&gt;": 9.828125,
    "?": 6.515625,
    "~": 9.828125,
    "`": 3.765625
}

const CHART_WIDTH_S16FN = {
    "0": 8.90625,
    "1": 6.15625,
    "2": 8.90625,
    "3": 8.90625,
    "4": 9.171875,
    "5": 8.90625,
    "6": 8.90625,
    "7": 8.625,
    "8": 8.90625,
    "9": 8.90625,
    "q": 9.6875,
    "w": 11.703125,
    "e": 8.734375,
    "r": 5.703125,
    "t": 5.140625,
    "y": 7.828125,
    "u": 9.25,
    "i": 3.546875,
    "o": 9.703125,
    "p": 9.6875,
    "a": 8.546875,
    "s": 6.71875,
    "d": 9.6875,
    "f": 4.765625,
    "g": 9.6875,
    "h": 9.25,
    "j": 3.546875,
    "k": 7.671875,
    "l": 3.546875,
    "z": 8.015625,
    "x": 7.28125,
    "c": 7.671875,
    "v": 7.828125,
    "b": 9.6875,
    "n": 9.25,
    "m": 14.203125,
    "Q": 13.03125,
    "W": 15.46875,
    "E": 8.640625,
    "R": 9.59375,
    "T": 8.84375,
    "Y": 9.328125,
    "U": 11.203125,
    "I": 3.9375,
    "O": 13.15625,
    "P": 9.40625,
    "A": 10.875,
    "S": 8.59375,
    "D": 11.640625,
    "F": 8.03125,
    "G": 11.546875,
    "H": 11.703125,
    "J": 5.609375,
    "K": 9.109375,
    "L": 7.921875,
    "Z": 9.84375,
    "X": 9.734375,
    "C": 10.734375,
    "V": 10.4375,
    "B": 9.40625,
    "N": 12.25,
    "M": 14.390625,
    "-": 6.875,
    "=": 11.234375,
    "[": 4.875,
    " ": 4.734375,
    "]": 4.875,
    ";": 3.84375,
    "'": 3.703125,
    ",": 3.84375,
    ".": 3.84375,
    "·": 3.84375,
    "/": 6.328125,
    "!": 4.921875,
    "@": 16.3125,
    "#": 10.4375,
    "$": 8.90625,
    "%": 13.546875,
    "^": 11.234375,
    "&": 12.046875,
    "*": 7.015625,
    "(": 4.875,
    ")": 4.875,
    "_": 7.171875,
    "+": 11.234375,
    "{": 4.875,
    "}": 4.875,
    ":": 3.84375,
    "\"": 5.796875,
    "&lt;": 11.234375,
    "&gt;": 11.234375,
    "?": 7.4375,
    "~": 11.234375,
    "`": 4.296875
}

const CHART_WIDTH_S12F6 = {
    "0": 7.40625,
    "1": 7.40625,
    "2": 7.40625,
    "3": 7.40625,
    "4": 7.40625,
    "5": 7.40625,
    "6": 7.40625,
    "7": 7.40625,
    "8": 7.40625,
    "9": 7.40625,
    "q": 7.984375,
    "w": 10.21875,
    "e": 6.984375,
    "r": 5.09375,
    "t": 4.96875,
    "y": 6.890625,
    "u": 7.78125,
    "i": 3.5625,
    "o": 7.890625,
    "p": 8,
    "a": 6.9375,
    "s": 5.9375,
    "d": 7.984375,
    "f": 4.875,
    "g": 7.984375,
    "h": 7.75,
    "j": 3.625,
    "k": 7.15625,
    "l": 3.5625,
    "z": 6.171875,
    "x": 7.03125,
    "c": 6.203125,
    "v": 6.9375,
    "b": 8,
    "n": 7.78125,
    "m": 11.796875,
    "Q": 9.828125,
    "W": 12.921875,
    "E": 6.875,
    "R": 8.390625,
    "T": 7.515625,
    "Y": 7.78125,
    "U": 9.328125,
    "I": 4.03125,
    "O": 9.828125,
    "P": 7.890625,
    "A": 9.03125,
    "S": 7.21875,
    "D": 9.5,
    "F": 6.703125,
    "G": 9.1875,
    "H": 9.859375,
    "J": 5.65625,
    "K": 8.328125,
    "L": 6.5625,
    "Z": 7.8125,
    "X": 8.40625,
    "C": 8.09375,
    "V": 8.578125,
    "B": 8.203125,
    "N": 10.1875,
    "M": 12.34375,
    "-": 5.25,
    "=": 9.140625,
    "[": 4.6875,
    " ": 3.578125,
    "]": 4.6875,
    ";": 3.4375,
    "'": 3.703125,
    ",": 3.4375,
    ".": 3.4375,
    "·": 5.28125,
    "/": 5.671875,
    "!": 4.1875,
    "@": 12.359375,
    "#": 7.6875,
    "$": 7.40625,
    "%": 11.1875,
    "^": 9.140625,
    "&": 10.9375,
    "*": 5.859375,
    "(": 4.6875,
    ")": 4.6875,
    "_": 5.390625,
    "+": 9.140625,
    "{": 4.6875,
    "}": 4.6875,
    ":": 3.4375,
    "\"": 6.265625,
    "&lt;": 9.140625,
    "&gt;": 9.140625,
    "?": 5.703125,
    "~": 9.140625,
    "`": 4.015625
}

const CHART_WIDTH_S14F6 = {
    "0": 8.640625,
    "1": 8.640625,
    "2": 8.640625,
    "3": 8.640625,
    "4": 8.640625,
    "5": 8.640625,
    "6": 8.640625,
    "7": 8.640625,
    "8": 8.640625,
    "9": 8.640625,
    "q": 9.3125,
    "w": 11.921875,
    "e": 8.15625,
    "r": 5.9375,
    "t": 5.796875,
    "y": 8.046875,
    "u": 9.078125,
    "i": 4.15625,
    "o": 9.203125,
    "p": 9.328125,
    "a": 8.09375,
    "s": 6.921875,
    "d": 9.3125,
    "f": 5.6875,
    "g": 9.3125,
    "h": 9.046875,
    "j": 4.234375,
    "k": 8.359375,
    "l": 4.15625,
    "z": 7.203125,
    "x": 8.203125,
    "c": 7.234375,
    "v": 8.09375,
    "b": 9.328125,
    "n": 9.078125,
    "m": 13.75,
    "Q": 11.46875,
    "W": 15.078125,
    "E": 8.015625,
    "R": 9.78125,
    "T": 8.765625,
    "Y": 9.078125,
    "U": 10.875,
    "I": 4.703125,
    "O": 11.46875,
    "P": 9.203125,
    "A": 10.53125,
    "S": 8.421875,
    "D": 11.09375,
    "F": 7.828125,
    "G": 10.71875,
    "H": 11.5,
    "J": 6.59375,
    "K": 9.703125,
    "L": 7.65625,
    "Z": 9.109375,
    "X": 9.8125,
    "C": 9.4375,
    "V": 10.015625,
    "B": 9.578125,
    "N": 11.875,
    "M": 14.40625,
    "-": 6.125,
    "=": 10.671875,
    "[": 5.46875,
    " ": 4.171875,
    "]": 5.46875,
    ";": 4,
    "'": 4.328125,
    ",": 4,
    ".": 4,
    "·": 6.15625,
    "/": 6.625,
    "!": 4.890625,
    "@": 14.421875,
    "#": 8.96875,
    "$": 8.640625,
    "%": 13.046875,
    "^": 10.671875,
    "&": 12.765625,
    "*": 6.828125,
    "(": 5.46875,
    ")": 5.46875,
    "_": 6.28125,
    "+": 10.671875,
    "{": 5.46875,
    "}": 5.46875,
    ":": 4,
    "\"": 7.296875,
    "&lt;": 10.671875,
    "&gt;": 10.671875,
    "?": 6.640625,
    "~": 10.671875,
    "`": 4.671875
}

const CHART_WIDTH_S16F6 = {
    "0": 9.875,
    "1": 9.875,
    "2": 9.875,
    "3": 9.875,
    "4": 9.875,
    "5": 9.875,
    "6": 9.875,
    "7": 9.875,
    "8": 9.875,
    "9": 9.875,
    "q": 10.640625,
    "w": 13.625,
    "e": 9.3125,
    "r": 6.78125,
    "t": 6.625,
    "y": 9.1875,
    "u": 10.375,
    "i": 4.734375,
    "o": 10.515625,
    "p": 10.65625,
    "a": 9.25,
    "s": 7.90625,
    "d": 10.640625,
    "f": 6.484375,
    "g": 10.640625,
    "h": 10.328125,
    "j": 4.828125,
    "k": 9.546875,
    "l": 4.734375,
    "z": 8.21875,
    "x": 9.359375,
    "c": 8.265625,
    "v": 9.234375,
    "b": 10.65625,
    "n": 10.375,
    "m": 15.71875,
    "Q": 13.09375,
    "W": 17.21875,
    "E": 9.15625,
    "R": 11.171875,
    "T": 10.015625,
    "Y": 10.375,
    "U": 12.421875,
    "I": 5.375,
    "O": 13.09375,
    "P": 10.515625,
    "A": 12.03125,
    "S": 9.625,
    "D": 12.671875,
    "F": 8.9375,
    "G": 12.25,
    "H": 13.140625,
    "J": 7.53125,
    "K": 11.09375,
    "L": 8.75,
    "Z": 10.40625,
    "X": 11.203125,
    "C": 10.78125,
    "V": 11.4375,
    "B": 10.9375,
    "N": 13.578125,
    "M": 16.453125,
    "-": 6.984375,
    "=": 12.1875,
    "[": 6.234375,
    " ": 4.765625,
    "]": 6.234375,
    ";": 4.578125,
    "'": 4.9375,
    ",": 4.578125,
    ".": 4.578125,
    "·": 7.03125,
    "/": 7.5625,
    "!": 5.578125,
    "@": 16.484375,
    "#": 10.25,
    "$": 9.875,
    "%": 14.90625,
    "^": 12.1875,
    "&": 14.578125,
    "*": 7.796875,
    "(": 6.234375,
    ")": 6.234375,
    "_": 7.171875,
    "+": 12.1875,
    "{": 6.234375,
    "}": 6.234375,
    ":": 4.578125,
    "\"": 8.34375,
    "&lt;": 12.1875,
    "&gt;": 12.1875,
    "?": 7.59375,
    "~": 12.1875,
    "`": 5.34375
}

/**
 * texts: string 
 * fontSize: number 
 * fontHeight: number 
 * fontWeight: number 
 * wMode: string 
 * valign: string 
 * textAnchor: string
 * w: number 
 * h: number 
 * x: number 
 * y: number
 */

export default function paintTextWrap(textConfig) {
    const textParams = computedLinesNum(textConfig)
    const textDoms = []

    let currTexts = textConfig.texts

    for (let lineNO = 1; lineNO <= textParams.lineNums; lineNO++) {
        const res = getLineTextInfo(currTexts, textConfig, textParams)

        if (textConfig.wMode === "tb") {
            textDoms.push({
                text: res.txt,
                x: textConfig.x + (lineNO - 1 / 2) * textConfig.fontSize,
                y: textConfig.y,
                len: res.txtWidth
            })
        } else {
            textDoms.push({
                text: res.txt,
                x: textConfig.x,
                y: textConfig.y + lineNO * textConfig.fontSize,
                len: res.txtWidth
            })
        }

        currTexts = res.restText

        if (currTexts.length == 0) {
            break;
        }
    }

    textDoms.map(txtItem => {
        const [shiftX, shiftY] = computedLoc(textConfig, txtItem.len, textDoms.length)

        txtItem.x += shiftX
        txtItem.y += shiftY
    })

    let isEllipsis = currTexts.length > 0

    if (isEllipsis) {
        let txt = textDoms[textDoms.length - 1].text
        textDoms[textDoms.length - 1].text = txt.substr(0, txt.length - 1) + "…"
    }

    return { textDoms, isEllipsis }

}

function computedLoc(textConfig, len, realLines) {
    let shiftY = 0
    let shiftX = 0

    if (textConfig.wMode === "tb") {
        // 横向偏移
        shiftX = (textConfig.w - realLines * textConfig.fontSize) / 2

        // 纵向偏移
        switch (textConfig.valign) {
            case "center":
                shiftY = (textConfig.h - len) / 2
                break;
            case "bottom":
                shiftY = (textConfig.h - len)
                break;
        }
    } else {
        // 纵向偏移
        switch (textConfig.valign) {
            case "center":
                shiftY = (textConfig.h - realLines * textConfig.fontHeight) / 2
                break;
            case "bottom":
                shiftY = (textConfig.h - realLines * textConfig.fontHeight)
                break;
        }

        // 横向偏移
        switch (textConfig.textAnchor) {
            case "middle":
                shiftX = (textConfig.w - len) / 2
                break;
            case "end":
                shiftX = (textConfig.w - len)
                break;
        }
    }

    return [shiftX, shiftY]
}

function getLineTextInfo(currTexts, textConfig, textParams) {
    let txt = ""
    let step = 0
    let txtWidth = 2

    for (; step < currTexts.length; step++) {
        const charWidth = getChartWidth(currTexts[step], textConfig.fontSize, textConfig.fontWeight, textConfig.wMode)
        if (txtWidth + charWidth <= textParams.textLineWidth) {
            txt += currTexts[step]
            txtWidth += charWidth
        } else {
            break;
        }
    }

    return {
        txt,
        txtWidth,
        restText: currTexts.slice(step)
    }
}

function getChartWidth(chartCode = "", fontSize = 14, fontWeight = 500, wMode = "tb") {
    let width = 0

    if (chartCode.charCodeAt(0) > 255) {
        width = fontSize
    } else {
        let cwType = "S" + fontSize + "F" + (fontWeight >= 600 ? "6" : "N")
        switch (cwType) {
            case "S12FN":
                width = CHART_WIDTH_S12FN[chartCode]

                break;
            case "S14FN":
                width = CHART_WIDTH_S14FN[chartCode]
                break;
            case "S16FN":
                width = CHART_WIDTH_S16FN[chartCode]
                break;
            case "S12F6":
                width = CHART_WIDTH_S12F6[chartCode]
                break;
            case "S14F6":
                width = CHART_WIDTH_S14F6[chartCode]
                break;
            case "S16F6":
                width = CHART_WIDTH_S16F6[chartCode]
                break;
        }
    }

    return width
}

function computedLinesNum(params) {
    let textLineWidth = 0
    let lineNums = 0

    if (params.wMode === "tb") {
        textLineWidth = params.h
        lineNums = Math.floor(params.w / params.fontSize)
    } else {
        textLineWidth = params.w
        lineNums = Math.floor(params.h / params.fontHeight)
    }

    return {
        textLineWidth,
        lineNums
    }
}